import axios from "axios";
import { apiServicesUrl } from "./baseUrl";
import { formatDate, userAccessToken } from "../helpers";
import { Config } from "../Config";

export const fetchFidelisdata = (filter) => {
  const {
    account_id,
    location_id,
    page,
    per_page,
    search_term,
    start_date,
    end_date,
    gender,
    visit_status,
    practice_location,
    order_by
  } = filter;

  let searchParam = search_term ? `&search_term=${search_term}` : "";
  let startDate = start_date ? `&start_date=${formatDate(start_date)}` : "";
  let endDate = end_date ? `&end_date=${formatDate(end_date)}` : "";
  let searchGender = gender ? `&gender=${gender}` : "";
  let visitStatus = visit_status ? `&visit_status=${visit_status}` : "";
  let practiceLocation = practice_location ? `&practice_location=${practice_location}` : "";
  let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";

  return axios.get(
    `${apiServicesUrl}/fidelis-care/list?account_id=${account_id}&location_id=${location_id}&page=${page}&per_page=${per_page}${searchParam}${startDate}${searchGender}${endDate}${visitStatus}${practiceLocation}${orderBy}`,
    {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    }
  );
};

export const uploadFidelisPatient = async (data) => {
  try {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });

    const response = await axios.post(
      `${apiServicesUrl}/fidelis-care/bulk-upload`, formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const submitBulkFidelisAllMessage = async (formData) => {
  try {
    const response = await axios.post(`${apiServicesUrl}/fidelis-care/sent_all`, formData,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const deleteFidelisPatient = async (id, account_id, location_id) => {
  try {
    const response = await axios.delete(
      `${apiServicesUrl}/fidelis-care/delete?account_id=${account_id}&location_id=${location_id}&fidelis_id=${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const fetchFidelisFilterData = (account_id, location_id) => {
  return axios.get(
    `${apiServicesUrl}/fidelis-care/filter_options?account_id=${account_id}&location_id=${location_id}`,
    {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    }
  );
};

export const fetchFidelisPatientHistory = (account_id, location_id, emr_patient_id) => {
  let emrPatientId = emr_patient_id ? `&emr_patient_id=${emr_patient_id}` : "";

  return axios.get(
    `${Config.notificationServerUrl}/fidelis-care/message-history?account_id=${account_id}&location_id=${location_id}${emrPatientId}`,
    {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    }
  );
};

export const deleteBulkFidelisData = async (deleteData) => {
  try {
    const response = await axios.delete(`${apiServicesUrl}/fidelis-care/bulk-delete`, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
      data: deleteData,
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const fetchFidelisPatientMessageSummery = (filter) => {
  const {
    account_id,
    location_id,
    start_date,
    end_date
  } = filter;
  if (account_id === 0) {
    return false;
  }

  let startDate = start_date ? `&start_date=${start_date}` : "";
  let endDate = end_date ? `&end_date=${end_date}` : "";

  return axios.get(
    `${Config.notificationServerUrl}/fidelis-care/messages_status?account_id=${account_id}&location_id=${location_id}${startDate}${endDate}`,
    {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    }
  );
};

export const fetchFidelisIncomingMessage = async (filter) => {
  const { page, per_page, account_id, location_id, search_term, start_date, end_date, order_by } = filter;

  try {
    let searchParam = search_term ? `&search_term=${search_term}` : "";
    let startDate = start_date ? `&start_date=${formatDate(start_date)}` : "";
    let endDate = end_date ? `&end_date=${formatDate(end_date)}` : "";
    let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";

    const response = await axios.get(
      `${Config.notificationServerUrl}/fidelis-care/message-received?account_id=${account_id}&location_id=${location_id}&page=${page}&per_page=${per_page}${searchParam}${startDate}${endDate}${orderBy}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {}
};

export const fetchFidelisOutgoingMessage = async (filter) => {
  const { page, per_page, account_id, location_id, start_date, end_date, search_term, status, template_id, practice_location, order_by } = filter;

  try {
    let searchParam = search_term ? `&search_term=${search_term}` : "";
    let startDate = start_date ? `&start_date=${start_date}` : "";
    let endDate = end_date ? `&end_date=${end_date}` : "";
    let sStatus = status ? `&status=${status}` : "";
    let templateId = template_id ? `&template_id=${template_id}` : "";
    let practiceLocation = practice_location ? `&practice_location=${practice_location}` : "";
    let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";

    const response = await axios.get(
      `${Config.notificationServerUrl}/fidelis-care/message-transaction?account_id=${account_id}&location_id=${location_id}&page=${page}&per_page=${per_page}${searchParam}${startDate}${endDate}${sStatus}${templateId}${practiceLocation}${orderBy}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {}
};

export const exportAllOutgoingMessage = async (filter) => {
  const { per_page, account_id, location_id, start_date, end_date, search_term, status, template_id, practice_location, order_by } = filter;

  try {
    let searchParam = search_term ? `&search_term=${search_term}` : "";
    let Status = status ? `&status=${status}` : "";
    let dosFrom = start_date ? `&start_date=${start_date}` : "";
    let dosTo = end_date ? `&end_date=${end_date}` : "";
    let templateId = template_id ? `&template_id=${template_id}` : "";
    let practiceLocation = practice_location ? `&practice_location=${practice_location}` : "";
    let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";

    return axios.get(`${Config.notificationServerUrl}/fidelis-care/outgoing-export?account_id=${account_id}&location_id=${location_id}&page=1&per_page=${per_page}${searchParam}${Status}${dosFrom}${dosTo}${templateId}${practiceLocation}${orderBy}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
  } catch (error) {}
};
